import { useCallback } from 'react';
import { Flex, Switch } from '@banhala/ui-kit';
import type { HeadlineSmallOneLineToggleProps } from './types';
import { isNil } from '../../../../utils';
import { HTMLText } from '../../../HTMLText';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';
import { useFilterListAtom } from '../../ItemList/FilterList/Provider/filterList/useFilterListAtom';

export const HeadlineSmallOneLineToggle = ({
  header,
  screen,
  scrollToFilterList,
}: HeadlineSmallOneLineToggleProps) => {
  const { setFilterListAtom } = useFilterListAtom();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handleToggle = useCallback(
    (nextValue: boolean) => {
      if (isNil(header)) return;

      logAnalyticsEvent({
        name: 'CLICK_HEADLINE_SMALL_ONE_LINE_TOGGLE',
        analytics: { ...header.logging.analytics, IS_ON: nextValue, ...(screen != null && { SCREEN: screen }) },
        ably_only_log: header.logging.ably_only_log,
      });

      scrollToFilterList?.();
      setFilterListAtom(prev => ({
        ...prev,
        [header.item.query_name]: nextValue
          ? [header.item.query_value]
          : undefined,
      }));
    },
    [header, screen, scrollToFilterList, setFilterListAtom, logAnalyticsEvent],
  );

  if (isNil(header)) return null;

  return (
    <Flex.Row
      padding={{ top: 24, bottom: 16, horizontal: 16 }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Flex flex={1}>
        <HTMLText type="h5" color="content_primary">
          {header.item.title}
        </HTMLText>
      </Flex>
      <Switch value={header.item.is_on} onChange={handleToggle} />
    </Flex.Row>
  );
};
